/**
 * Created by PuTi(编程即菩提) 11/14/16.
 */
var nb = require('../../nb');
var $ = nb.opts.$;
console.log('../../config/' + process.env.APP_CONFIG + '.json');
var config = require('../../config/' + process.env.APP_CONFIG + '.json');
// var config = require('../../config/product.json');
var alerts = require('../../model/Alerts');
var Form = nb.define({
    view: {
        tag: 'form',
        //enctype:"multipart/form-data",
        $html: [
            {
                tag: 'input',
                type: 'hidden',
                $name: 'cmd',
                name: 'cmd'
            },
            {
                tag: 'input',
                type: 'hidden',
                $name: 'token',
                name: 'token'
            }
            ,
            {
                $name: 'parameters',
                tag: 'input',
                type: 'hidden',
                name: 'parameters'
            }
        ]
    },
    method: {
        setCMD: function (inCMD) {
            this.$('cmd').val(inCMD);
        },
        setToken: function (inToken) {
            this.$('token').val(inToken);
        },
        setParameters: function (inData) {
            if (inData) {
                this.$('parameters').val(JSON.stringify(inData));
            }
        }
    }
});

function createUIID() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

var token;
var uiid = createUIID();
//var url = 'http://shbank.txpc.cn:8080/cgi';
//var url = app.config.cgiUrl;
var url = config.cgiUrl;

function callErrorCallback(inError, inScope, inResult) {
    var error = inResult.error;
    if (inError) {
        inError.call(inScope, inResult);
    } else {
        // toast.setOpts({
        //     text: error.info||error.errorInfo,
        //     duration: 2
        // });
    }
}

var ajax = function (inOpts) {
    var opts = inOpts || {};
    var scope = opts.scope;
    var data = opts.data || {};
    var formData = opts.formData;
    var success = opts.success;
    var error = opts.error;
    var always = opts.always;
    var parameters = {};
    var cmd = inOpts.cmd;
    var ajaxOpts = {
        url: opts.url || url,
        type: 'post',
        cache: false,
        crossDomain: true
    };
    var openId = nb.model.get('openId');
    jQuery.support.cors = true;
    $.ajaxSetup({cache:false});
    $.each(data, function (inName, inValue) {
        parameters[inName] = inValue;
    });

    if (openId) {
        parameters.openId = openId;
    }
    if (formData) {
        formData.append('cmd', cmd);
        formData.append('parameters', JSON.stringify(parameters));
        ajaxOpts.data = formData;
        ajaxOpts.processData = false;  // 告诉jQuery不要去处理发送的数据
        ajaxOpts.contentType = false;   // 告诉jQuery不要去设置Content-Type请求头
    } else {
        ajaxOpts.dataType = 'json';
        ajaxOpts.data = JSON.stringify({
            cmd: cmd,
            parameters: parameters,
            clientIdentifierCode: uiid,
            token: token
        });
        ajaxOpts.contentType = "application/json";
    }
    $.ajax(ajaxOpts).done(function (inResult) {
        var statusCode = inResult.statusCode;
        switch (statusCode) {
            case 0:
                var response = inResult.response;
                if (success) {
                    success.call(scope, response);
                }
                break;
            case 401:
                $.cookie('ARTW_token','');
                $.cookie('ARTW_nickname','');
                $.cookie('ARTW_user_mobile','');
                $.cookie('ARTW_user_password','');
                $.cookie('selected_pay_orderId','');
                $.cookie('pay_status_result','');
                alerts.setOpts({
                    status: 'alert-danger',
                    text: inResult.error.info
                });
                setTimeout(function () {
                    window.location.href = 'login.html';
                }, 2000);
                break;
            case 412:
            case 403:
            case 410:
            case 500:
                callErrorCallback(error, scope, inResult);
                break;
            default:
        }
    }).always(function () {
        if (always) {
            always.call(scope);
        }
    }).fail(function () {
        //TODO ajax请求错误处理,例如网络不可访问
        // toast.setOpts({
        //     text: '网络无法访问',
        //     duration: 2
        // });
    });
};
var uploadImage = function (inOpts) {
    var opts = inOpts || {};
    var data = opts.data;
    var deferred;
    var _timeout = 60000; // 上传超时时间，单位毫秒
    var _timeoutHandle = null;
    var $input = inOpts.$input;
    var form = new Form();
    var $form = form.$();
    var scope = opts.scope;
    var success = opts.success;
    var error = opts.error;
    var always = opts.always;
    form.setParameters(data);
    form.setToken(token);
    form.setCMD(opts.cmd);
    $input.attr('name', 'files');
    $form.append($input);
    if (window.FormData) {
        var formData = new FormData($form[0]);
        //var formData = new FormData();
        //formData.append('files', $input[0].files[0]);
        //formData.append('cmd', 'artbase/uploadImage');
        //formData.append('parameters', JSON.stringify({type:'shop'}));

        deferred = $.ajax({
            url: app.config.uploadUrl,
            type: "post",
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false
        });
    }
    deferred.done(function (inResult) {
        var statusCode = inResult.statusCode;
        switch (statusCode) {
            case 0:
                var response = inResult.response;
                if (success) {
                    success.call(scope, response);
                }
                break;
            case 412:
            case 401:
            case 403:
            case 410:
            case 500:
                if (error) {
                    error.call(scope, inResult);
                } else {
                    //todo 错误
                    // toast.setOpts({
                    //     text: inResult.error.errorInfo,
                    //     duration: 2
                    // });
                }
                break;
            default:
        }
    }).always(function () {
        if (always) {
            always.call(scope);
        }
    }).fail(function () {
        //TODO ajax请求错误处理,例如网络不可访问
        // toast.setOpts({
        //     text: '网络无法访问',
        //     duration: 2
        // });
    });

    deferred.promise();

};
module.exports = {
    ajax: ajax,
    uploadImage: uploadImage,
    getUiid: function () {
        return uiid;
    },
    setToken: function (inToken) {
        token = inToken;
    }
};



//////////////////
// WEBPACK FOOTER
// ../src/js/io/product/io.js
// module id = 1
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32